import React, { useState, useEffect } from "react";
import Field from "app/components/Elements/Field";
import isEmail from "app/helpers/isEmail";

import "./styles.scss";
import Checkbox from "app/components/Elements/Checkbox";

interface IFormData {
  email: string;
  username: string;
  name: string;
  password: string;
}

interface IProps {
  agreement?: boolean;
  onSubmit: (data: IFormData) => void;
  buttonText?: string;
  errors?: any;
}

const SignUpForm: React.FC<IProps> = props => {
  const [state, setState] = useState({
    email: "",
    password: "",
    username: "",
    name: ""
  });

  const [isError, setError] = useState({
    password: false,
    name: false,
    email: false
  });

  useEffect(() => {
    setError({
      email: state.email.length !== 0 && !isEmail(state.email),
      name: state.name.length !== 0 && state.name.length < 2,
      password: state.password.length !== 0 && state.password.length < 5
    });
  }, [state]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    state.username = state.email;

    state.email !== "" &&
      state.name !== "" &&
      state.password !== "" &&
      props.onSubmit(state);
  };

  return (
    <form onSubmit={handleSubmit} className="signup-form">
      <Field
        isError={isError.name}
        type="text"
        value={state.name}
        name="name"
        placeholder="имя"
        onChange={onChange}
        minLength={2}
      />
      <Field
        isError={isError.email}
        type="email"
        value={state.email}
        name="email"
        placeholder="емайл"
        onChange={onChange}
      />
      <Field
        isError={isError.password}
        type="password"
        value={state.password}
        name="password"
        placeholder="пароль"
        onChange={onChange}
        minLength={5}
      />

      {props.agreement && (
        <div className="signup-form__agreement">
          <Checkbox
            title="Я принимаю условия Пользовательского соглашения и даю своё согласие на
            обработку моей персональной информации на условиях, определенных
            Политикой конфиденциальности."
          />
        </div>
      )}

      <button className="signup-form__button">{props.buttonText}</button>
      {/* <div className="errors">
        {props.errors &&
          props.errors.map(error => (
            <div className="error" key={error.msg}>
              {error.msg}
            </div>
          ))}
      </div> */}
    </form>
  );
};

SignUpForm.defaultProps = { agreement: true, buttonText: "Зарегистрироватья" };

export default SignUpForm;
